module.exports = __webpack_public_path__ + "static/BodyTime-f845ca55a186d943ae8e8a2b8a1bbdf2.png";